import notificationFromJs from 'models/notification/notification_from_js';

export default {
  fromDto(attrs) {
    return notificationFromJs({
      ...attrs,
      id:
        (attrs.profile && attrs.profile.id) ||
        (attrs.conversationItem && attrs.conversationItem.id) ||
        attrs.conversationItemId ||
        attrs.id,
    });
  },

  toDto(notification) {
    return notification.toJs();
  },
};



// WEBPACK FOOTER //
// ./src/scripts/application/dto_converters/notification_converter.js